module.exports = __webpack_public_path__ + "img/icon6.cc108727.png";